import { styled } from 'styled-components';

import { ScContainer } from '@/styles/common';
import { device, hexToRGB, typography } from '@/styles/helpers';

export const ScCasinoClockUTC = styled(ScContainer)<{ isNoSticky: boolean }>`
  position: ${({ isNoSticky }) => (isNoSticky ? 'static' : 'sticky')};
  right: 0;
  bottom: 0;
  z-index: 20;
  text-align: right;
  margin-top: 48px;

  @media (${device.mobile}) {
    position: static;
    text-align: center;
  }

  & .utc-clock {
    ${typography['body2regular']};
    display: inline-flex;
    column-gap: 4px;
    color: ${({ theme }) => theme.whiteColor};
    border-radius: 16px 16px 0 0;
    padding: 8px 12px;
    transition: background-color 0.3s ease;
    background-color: ${({ theme }) => hexToRGB(theme.blackColor, 0.8)};
    backdrop-filter: blur(5px);

    & > .label {
      color: ${({ theme }) => theme.blackLightColor};
    }

    & .utc {
      text-transform: capitalize;
      font-variant-numeric: tabular-nums;
    }
  }

  & .sentinel {
    height: 1px;
    visibility: hidden;
    margin-bottom: -2px;
  }
`;
